import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import './style.scoped.scss';
import { DOWNLOAD_URL } from '../../../assets/constants/strings';

const Card = ({
  Icon,
  cardTitle,
  cardItems,
  onClickFunction,
  document,
  children,
}) => {
  const handleOnClick = (type) => {
    onClickFunction && onClickFunction(type);
  };

  const clearPath = (file, isPdf) => {
    return DOWNLOAD_URL(file, isPdf).replace(/&/g, '%26');
  };

  return (
    <div className="wf-card card">
      <div className="wf-card__title">
        {Icon} <p className="wf-card__title__text pl-3">{cardTitle}</p>
      </div>
      <div className="d-flex flex-column">
        <div
          className="wf-card__content"
        >
          {cardItems &&
            cardItems.map((item, index) => {
              if (item) {
                if (onClickFunction) {
                  // if instead of a link, we have a local on click function, return a clickable div
                  return (
                    <div key={index} onClick={() => handleOnClick(item.Text)}>
                      <p className="wf-card__item wf-card__item--clickable">{item.Text}</p>
                    </div>
                  );
                } else if (item.Text.match('PDF')) {
                  return (
                    <a key={index} target="_blank" rel="noreferrer" href={clearPath(document.fileName, true)}>
                      <p className="wf-card__item">{item.Text}</p>
                    </a>
                  );
                } else if (item.Text.match('Word')) {
                  return (
                    <a key={index} href={clearPath(document.fileName)}>
                      <p className="wf-card__item">{item.Text}</p>
                    </a>
                  );
                } else {
                  return (
                    // otherwise, just return the link
                    <Link key={index} to={item.Link ? item.Link : '/app'}>
                      <p className="wf-card__item">{item.Text}</p>
                    </Link>
                  );
                }
              } else return null;
            })}
          {children ? children : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  document: state.document.currentDocument,
});

const connector = connect(mapStateToProps, null);

export default connector(Card);
